export default __webpack_public_path__ + "static/media/Staatliches-Regular.13448228.ttf";